import React, { memo, useEffect, useMemo } from 'react'
import { noOp } from '../../../../shared/helpers'
import indicator from '../../assets/img/time-indicator-position.svg'
import dayjs from 'dayjs'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const localizedFormat = require('dayjs/plugin/localizedFormat')

import type { TimeLineProps } from './types'

dayjs.extend(localizedFormat)

const TimeLine = ({
  currentTime,
  focusedDate,
  hoursToDisplay = 2,
  slotDuration = 30,
  onScheduleRangeChange = noOp,
  timeIndicatorPosition = 0,
}: TimeLineProps) => {
  const slots = useMemo(() => {
    const now = dayjs(currentTime)
    const slotsQuantity = (hoursToDisplay * 60) / slotDuration
    const minutes = now.minute()
    const time1 =
      minutes >= 30
        ? dayjs(currentTime.minute(slotDuration))
        : dayjs(currentTime.minute(0))
    const scheduleTimes = [time1]
    for (let index = 0; index < slotsQuantity - 1; index++) {
      const newTime = scheduleTimes[index].add(slotDuration, 'minute')
      scheduleTimes.push(newTime)
    }

    return scheduleTimes
  }, [currentTime])

  useEffect(() => {
    onScheduleRangeChange({
      start: slots[0],
      end: slots[slots.length - 1].add(slotDuration, 'minute'),
    })
  }, [slots])

  return (
    <div className="epg__time-line">
      <div className="epg__time-line__day-slot">
        {focusedDate.format('ddd M/D').toUpperCase()}
      </div>
      <div className="epg__time-line__schedules-time-wrapper">
        <div className="epg__time-line__schedules-time">
          {slots.map((slot, index) => (
            <div className="epg__time-line__schedule" key={index}>
              {slot.format('LT')}
            </div>
          ))}
        </div>
        <img
          style={{
            left: `calc(${timeIndicatorPosition}% - 25px - 1.4px)`, //
            visibility: timeIndicatorPosition < 0 ? 'hidden' : 'visible',
          }}
          className="epg__time-line__time-indicator"
          src={indicator}
        />
      </div>
    </div>
  )
}

export default memo(TimeLine)
